import {
  operClassifyList,
  operClassifyName4role,
  operClassifyName4User,
} from '@/config';
import { mapGetters } from 'vuex';

export default {
  props: {
    visible: Boolean,
    resetDialog: Function,
    type: Number, // 0 新增 1 修改
    selected: Object,
    submitUpdateHandle: Function,
    cancelHandle: Function,
  },
  computed: {
    ...mapGetters(['loading']),
  },
  methods: {
    updateVisibleHandle(val) {
      this.$emit('update:visible', val);
    },
    getOperClassifyName(val) {
      let item = operClassifyList.find(item => item.value === val);
      return item ? item.label : val;
    },

    getOperClassifyName4role(val) {
      let item = operClassifyName4role.find(item => item.value === val);
      return item ? item.label : val;
    },

    getOperClassifyName4User(val) {
      let item = operClassifyName4User.find(item => item.value === val);
      return item ? item.label : val;
    },
  },
};
